import type { Report } from "@/mocks/partes";

interface PartyReportsGridProps {
  reports: Report[];
}

const statusLabels: Record<string, string> = {
  disponivel: "Disponível",
  gerando: "Gerando...",
  pendente: "Pendente",
};

const statusStyles: Record<string, string> = {
  disponivel: "bg-primary-100 text-primary-700",
  gerando: "bg-warning-100 text-warning-700",
  pendente: "bg-background-100 text-foreground-500",
};

export default function PartyReportsGrid({ reports }: PartyReportsGridProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Relatórios disponíveis</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {reports.map((report) => (
          <div key={report.id} className="bg-white rounded-xl border border-background-200/70 p-4 flex flex-col hover:border-background-300 transition-colors">
            <div className="w-10 h-10 rounded-lg bg-secondary-50 flex items-center justify-center mb-3">
              <i className="ri-file-text-line text-secondary-500 w-full h-full flex items-center justify-center text-xl" />
            </div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-1 font-heading">{report.title}</h4>
            <p className="text-xs text-foreground-500 mb-3 line-clamp-2">{report.description}</p>
            <div className="flex items-center justify-between mb-3">
              <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${statusStyles[report.status] || "bg-background-100 text-foreground-500"}`}>
                {statusLabels[report.status] || report.status}
              </span>
              <span className="text-xs text-foreground-400">{report.lastGenerated}</span>
            </div>
            <div className="flex gap-2 mt-auto">
              <button className="flex-1 px-3 py-1.5 text-xs font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap">
                <i className="ri-play-circle-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
                Gerar
              </button>
              <button className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap">
                <i className="ri-eye-line w-3.5 h-3.5 inline-flex items-center justify-center" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}